import React, { use } from 'react';

import HostedImage from 'src/components/common/hosted-image';
import { SiteContext } from 'src/context/site-context';
import { amplitudeLinkTrackEvent } from 'src/helpers/amplitude-event-track';

import * as styles from './app-links-section.module.scss';

type AppLinksSectionProps = {
  title?: string | null;
  images: readonly Queries.FooterImage[];
  footerImageHeight: string[];
};

const AppLinksSection = ({ title, images, footerImageHeight }: AppLinksSectionProps) => {
  const { pageLevel } = use(SiteContext);
  const { buildType, language } = use(SiteContext);
  const handleClick = (name: string | null, path: string) => {
    void amplitudeLinkTrackEvent({
      buildType,
      language,
      linkName: name,
      linkPath: path,
      componentName: 'Footer App link',
      pageLevel,
      name,
    });
  };

  return (
    <div
      className={styles.wrapper}
      style={
        {
          '--footer-image-height': footerImageHeight[0],
          '--footer-image-height-desktop': footerImageHeight[1],
        } as React.CSSProperties
      }
    >
      {title && <div className={styles.sectionTitle}>{title}</div>}
      <div className={styles.appLinks}>
        {(images ?? []).map((image, index) => (
          <div key={`app-link-section-${index}`}>
            <a
              className={styles.imageLink}
              href={image.link}
              target={image.openInNewTab ? '_blank' : '_self'}
              rel="noopener noreferrer"
              onClick={() => handleClick(image.image.alternateText, image.link)}
            >
              <HostedImage imageDetails={image.image} loading="lazy" />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export { AppLinksSection };
